module.exports = __webpack_public_path__ + "res/Roboto-MediumItalic-webfont.woff?94ad8f3aa874fe55a9947a942323f83f";


//////////////////
// WEBPACK FOOTER
// ./assets/fonts/roboto/Roboto-MediumItalic-webfont.woff
// module id = 78
// module chunks = 0